//external
import React, { createContext, useEffect, useState } from 'react';
import { useLocation } from 'react-router';
//internal
import Route from '../../routes/Route';
import Intention from './list';
import IntentionEdit from './edit';

export const FilterRtpiIntention = createContext({});

export default function Routes() {
  const [filter, setFilter] = useState({
    search: "",
    page: 1,
  });

  let location = useLocation();

  useEffect(() => {
    const split = location?.pathname.split('/');
    if (split[3] !== "rtpi_intention") {
      setFilter({
        search: "",
        page: 1,
      });
    }
  }, [location, setFilter]);

  return (
    <FilterRtpiIntention.Provider value={{ filter, setFilter }}>
      <Route path="/premixlabel/rtpi/rtpi_intention" exact component={Intention} isPrivate/>
      <Route path="/premixlabel/rtpi/rtpi_intention/edit/:intentionId" exact component={IntentionEdit} isPrivate/>
      <Route path="/premixlabel/rtpi/rtpi_intention/approve/:intentionId" exact component={IntentionEdit} isPrivate/>
    </FilterRtpiIntention.Provider>
  )
}